<div
  class="card border-bottom-primary shadow py-1 bloque-1"
  [style.color]="borderBottomColor"
>
  <div class="card-body">
    <div class="row no-gutters align-items-center pl-1">
      <div class="col-12 mr-2">
        <div class="text-secondary text-uppercase text-xs mb-1">
          {{ title }}
        </div>
      </div>
      <div class="col-1" [title]="tooltip1" >
        <i class="fa-xl text-gray-500" [class]="icon"></i>
      </div>
      <div class="col-6" [title]="tooltip1" >
        <div class="h4 mb-0 font-weight-bold text-gray-800 pl-2">
          <div *ngIf="!isLoading">{{ value }}</div>
          <p-skeleton *ngIf="isLoading" />
        </div>
      </div>
      <div class="col-1" [title]="tooltip2" >
        <i class="fa text-gray-500" [class]="detailIcon"></i>
      </div>
      <div class="col-4" [title]="tooltip2" >
        <span class="pl-2" *ngIf="!isLoading">{{ detailValue }}</span>
        <p-skeleton *ngIf="isLoading" />
      </div>
    </div>
  </div>
</div>
